import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enHeader from './locales/en/header.json';
import enFooter from './locales/en/footer.json';
import enHome from './locales/en/home.json';
import enService from './locales/en/service.json';
import enBanner from './locales/en/banner.json';
import enMail from './locales/en/mail.json';

import deHeader from './locales/de/header.json';
import deFooter from './locales/de/footer.json';
import deHome from './locales/de/home.json';
import deService from './locales/de/service.json';
import deBanner from './locales/de/banner.json';
import deMail from './locales/de/mail.json';

import esHeader from './locales/es/header.json';
import esFooter from './locales/es/footer.json';
import esHome from './locales/es/home.json';
import esService from './locales/es/service.json';
import esBanner from './locales/es/banner.json';
import esMail from './locales/es/mail.json';

import frHeader from './locales/fr/header.json';
import frFooter from './locales/fr/footer.json';
import frHome from './locales/fr/home.json';
import frService from './locales/fr/service.json';
import frBanner from './locales/fr/banner.json';
import frMail from './locales/fr/mail.json';

export const supportedLanguages = [
  { code: 'en', label: 'English' },
  { code: 'de', label: 'Deutsch' },
  { code: 'es', label: 'Español' },
  { code: 'fr', label: 'Français' },
] as const;

export const defaultNS = 'home';

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: supportedLanguages.map((l) => l.code),
    defaultNS,
    ns: ['header', 'footer', 'home', 'service', 'banner', 'mail'],
    resources: {
      en: { header: enHeader, footer: enFooter, home: enHome, service: enService, banner: enBanner, mail: enMail },
      de: { header: deHeader, footer: deFooter, home: deHome, service: deService, banner: deBanner, mail: deMail },
      es: { header: esHeader, footer: esFooter, home: esHome, service: esService, banner: esBanner, mail: esMail },
      fr: { header: frHeader, footer: frFooter, home: frHome, service: frService, banner: frBanner, mail: frMail },
    },
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'airooki_lang',
    },
  });

export default i18n;

const LANG_EXPLICIT_KEY = 'airooki_lang_explicit';
const supportedCodes = supportedLanguages.map((l) => l.code) as readonly string[];

/** Marks the current language as an explicit user choice, so it stops following the OS locale. */
export function setExplicitLanguage(code: string): void {
  window.localStorage.setItem(LANG_EXPLICIT_KEY, '1');
  void i18n.changeLanguage(code);
}

function resolveSystemLanguage(): string {
  for (const tag of navigator.languages ?? [navigator.language]) {
    const base = tag.split('-')[0].toLowerCase();
    if (supportedCodes.includes(base)) {
      return base;
    }
  }
  return 'en';
}

// Keep following the OS/browser language live for as long as the user hasn't
// explicitly picked one from the language switcher.
window.addEventListener('languagechange', () => {
  if (!window.localStorage.getItem(LANG_EXPLICIT_KEY)) {
    void i18n.changeLanguage(resolveSystemLanguage());
  }
});
